<div id="overlay">
    <div class="d-flex flex-column justify-content-center align-items-center p-0 m-0 min-vh-100 min-vw-100">
    @if (mode === _enumOverlayMode.DISPLAY) {
    } @else {
        <div role="status" class="spinner-border {{ color === _enumOverlayTextColor.ERROR ? 'text-danger' : color === _enumOverlayTextColor.SUCCESS ? 'text-success' : color === _enumOverlayTextColor.WARNING ? 'text-warning' : 'text-white' }}" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Loading . . .</span>
        </div>
        <div class="m-0 p-0 w-fit">
            {{ loadingText }}
        </div>
    }
    </div>
</div>